export default ({ req, store }) => {
  if (process.server) {
    store.commit('envs/set', {
      AMPLITUDE_API_KEY: process.env.AMPLITUDE_API_KEY
    })
  }
}
